// extracted by mini-css-extract-plugin
export default {"addAction":"AddGpsButton_addAction__BwyDB","ieFix":"AddGpsButton_ieFix__JLSXO","title":"AddGpsButton_title__9nPW3"};